import { useEffect, useState } from 'react';
import { collection, onSnapshot } from 'firebase/firestore';
import { db, firebaseReady } from '../../lib/firebase';

/** Live subscription to an entire collection (admin-only views). */
export function useAdminCollection<T extends { id: string }>(name: string) {
  const [items, setItems] = useState<T[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!firebaseReady) {
      setLoading(false);
      return;
    }
    return onSnapshot(
      collection(db(), name),
      (snap) => {
        setItems(snap.docs.map((d) => ({ id: d.id, ...d.data() }) as T));
        setLoading(false);
        setError('');
      },
      (err) => {
        setError(err.message);
        setLoading(false);
      },
    );
  }, [name]);

  return { items, loading, error };
}
